module.exports = __webpack_public_path__ + "static/media/analyzer-t.c709a939.png";